.sn-how-dynamic-works {
  me-row {
    @include desktop {
      column-gap: 90px;
    }
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);

    @include desktop {
      max-width: 396px;
      flex-shrink: 0;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, lg);
    flex: 1;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: map-get($spacings, lg);
  }

  &__arrow-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background-color: var(--color-neutral-neutral-lighter);
    flex-shrink: 0;
  }

  &__arrow {
    color: var(--text-color-primary); // TODO: no exact token (was #141212)
    flex-shrink: 0;
  }

  &__item-content {
    font-weight: 400;
    font-size: map-get($font-sizes, xxl);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
  }

  &__item-title {
    font-weight: 700;
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 4xl);
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, xl);
    line-height: map-get($line-heights, lg);
  }
}
